import React, { useEffect } from "react";
import { useApplicationContext } from "../../components/applicationComponents/context/applicationContext";
import KindergartenScreeningComponent from "../../components/applicationComponents/kindergartenScreening/KindergartenScreeningComponent";
import { PageHeader } from "../../components/header/PageHeader";
import { Header } from "../../components/header/Header";

export default function KindergartenScreeningPage() {
  const { setHeaderText } = useApplicationContext();
  const headerText = [
    {
      class: "flex items-center mt-0",
      value: "Create new application",
      icon: "view-app-icon icon-spec mr-3 mt-0 icon-spec",
    },
  ];
  useEffect(() => {
    setHeaderText({
      value: "Edit Kindergarten Details",
      icon: "view-app-icon icon-spec mr-3 mt-0 icon-spec",
    });
  }, []);

  return (
    <>
      <Header />
      <PageHeader headerText={headerText} icon={"icon"} />
      <KindergartenScreeningComponent disabled={false} />
    </>
  );
}
